import { makeAutoObservable } from 'mobx';
import { AccountLinkResponseDto, IIntegrationPreset } from '../../../../../models/IntegrationsTypes';
import { ICredentialsStore } from '../integration-store';
import IntegrationsService from '../../../../../services/api/integrations-service';
import { TYPE, rootContainer } from '../../../../../services/container/root';

interface IEventMessage {
    type: string;
    [payloadKey: string]: any;
}

const CLOSE_INTERVAL = 50;

interface IOAuthResponsePayload {
    code: string
    success: 'true'|'false';
}

class StripeOauthCredentialsStore implements ICredentialsStore {
    private _window = {} as Window;
    private _intervalId: any = undefined;
    private _messageHandler?: (event: IEventMessage) => void;

    constructor(private _presetValue: IIntegrationPreset) {
        makeAutoObservable(this);
    }

    private get integrationsService(): IntegrationsService {
		return rootContainer.get<IntegrationsService>(TYPE.IntegrationsService);
	}

    // Handle case when user didn't finish authorization flow and closed window
    private _listenToWindowClosed(reject: (reason?: any) => void) {
        /** make sure to always clear interval before starting new one */
        clearInterval(this._intervalId);

        this._intervalId = setInterval(() => {
            if (!this._window.closed) {
                return;
            }
            clearInterval(this._intervalId);
            reject(new Error('Authorization interrupted, window was closed before finishing the process'));
        }, CLOSE_INTERVAL);
    }

    private _handleMessage(event: IEventMessage, resolve: (value: unknown) => void, reject: (reason?: any) => void, linkResponse: AccountLinkResponseDto) {
        if (event.data?.type !== 'OAUTH_RESPOSE') {
            return;
        }

        this._window.close();
        window.removeEventListener('message', this._messageHandler as (event: IEventMessage) => void, false);

        const payload = event.data?.payload as IOAuthResponsePayload;
        console.log('oauth response payload', payload);
        if (payload.success === 'true') {
            return resolve(payload.code);
        }
        return reject('oauth invalid response, after auth attepmt stripe redirected to fail url (refreshUrl)');
    }

    private async _createAccountLink(isSandbox: boolean): Promise<AccountLinkResponseDto> {
        const serviceCode = this._presetValue.id;
        const response = await this.integrationsService.createAccountLink(serviceCode, undefined, isSandbox);
        return response;
    }

    /** ICredentialsStore implementation ************/
    public async getCredentials(isSandbox: boolean) {

        if (this._messageHandler) {
            window.removeEventListener('message', this._messageHandler, false);
        }

        return new Promise(async (resolve, reject) => {
            let linkResponse: AccountLinkResponseDto; 
            /** when we need to request the window popup url from server (integrator) */
            try {
                linkResponse = await this._createAccountLink(isSandbox);
            }
            catch (err) {
                reject(err);
                return;
            }

            this._window = window.open(linkResponse.authLink, '', 'width=800,height=600,resizeable,scrollbars') as Window;

            this._messageHandler = (event: IEventMessage) => {
                this._handleMessage(event, resolve, reject, linkResponse);
            };

            window.addEventListener('message', this._messageHandler, false);

            this._listenToWindowClosed(reject);
        }); 
    }
}

export default StripeOauthCredentialsStore;
